import { Chip } from "@mui/material"
import { UserbotTracking as T } from "../../interfaces"
import { TrackingListKind } from "../../store/trackingQuery"

// Explicit response field allowlists: never enumerate a server row or render JSON.
export const requestFields = [
  "id",
  "accountId",
  "sourceClientId",
  "targetKind",
  "chatId",
  "status",
  "requestedAt",
  "expiresAt",
  "lastCheckedAt",
  "nextCheckAt",
  "lastAttemptAt",
  "lastResult",
  "approvedChatId",
  "approvedAt",
  "completionOperationId",
  "createdAt",
  "updatedAt",
] as const satisfies readonly (keyof T.JoinRequest)[]
export const recoveryFields = [
  "id",
  "sourceTriggerId",
  "sourceClientId",
  "reason",
  "isActive",
  "createdAt",
] as const satisfies readonly (keyof T.JoinRecovery)[]
export const dialogFields = [
  "id",
  "accountId",
  "markedChatId",
  "kind",
  "isBaseline",
  "generation",
  "membershipStatus",
  "matchStatus",
  "archiveStatus",
  "archiveAttemptCount",
  "nextArchiveAttemptAt",
  "discoveredAt",
  "lastSeenAt",
  "createdAt",
  "updatedAt",
] as const satisfies readonly (keyof T.Dialog)[]
export const passFields = [
  "id",
  "accountId",
  "chainId",
  "kind",
  "state",
  "checksReserved",
  "pagesCaptured",
  "notBefore",
  "completedAt",
  "createdAt",
  "updatedAt",
] as const satisfies readonly (keyof T.DialogPass)[]
export const clarificationFields = [
  "id",
  "accountId",
  "chatId",
  "scanId",
  "passId",
  "expectedGeneration",
  "expectedObservedAt",
  "expiresAt",
  "state",
  "status",
] as const satisfies readonly (keyof T.MembershipClarification)[]

export const listFields = {
  requests: [
    "accountId",
    "sourceClientId",
    "targetKind",
    "chatId",
    "status",
    "requestedAt",
    "expiresAt",
    "lastResult",
    "nextCheckAt",
  ],
  recovery: recoveryFields,
  dialogs: [
    "accountId",
    "markedChatId",
    "kind",
    "isBaseline",
    "generation",
    "membershipStatus",
    "matchStatus",
    "archiveStatus",
    "archiveAttemptCount",
    "nextArchiveAttemptAt",
    "lastSeenAt",
  ],
  passes: passFields,
  clarifications: clarificationFields,
} as const
export type TrackingRow =
  | T.JoinRequest
  | T.JoinRecovery
  | T.Dialog
  | T.DialogPass
  | T.MembershipClarification

export function safeField(row: TrackingRow, field: string) {
  const value: unknown = (row as unknown as Record<string, unknown>)[field]
  if (field === "isBaseline")
    return value === true ? <Chip size="small" label="Базовый диалог" /> : "Нет"
  if (field === "isActive") return "Неактивен"
  if (value === null || value === undefined) return "—"
  return typeof value === "string" || typeof value === "number"
    ? String(value)
    : "—"
}

export const trackingTitles: Record<TrackingListKind, string> = {
  requests: "Заявки на вступление",
  recovery: "Карантин заявок",
  dialogs: "Обнаруженные диалоги",
  passes: "Проходы опроса",
  clarifications: "Уточнения участия",
}
export const trackingNotes: Record<TrackingListKind, string> = {
  requests:
    "Истечение заявки не доказывает выход. Отмена заявки не выполняет выход из Telegram.",
  recovery:
    "Неактивный карантин — только чтение метаданных. Активация и назначение аккаунта недоступны.",
  dialogs:
    "Личные диалоги не являются вступлением в группу. Match, архив и участие независимы; unmatched не означает left.",
  passes:
    "parked — отложенный, но незавершённый проход. notBefore — не раньше указанного времени.",
  clarifications:
    "Незавершённое подтверждение остаётся pending. Отсутствие не доказывает выход (left).",
}
